import React, { useState } from "react";
import Cookies from "js-cookie";

import {
  Root,
  Subtitle,
  Question,
  Desc,
  Fields,
  SelectWrapper,
  Select,
  Submit,
} from "./ModalAgeConfirm.style";

import Modal from "../Modal/Modal";

const ModalAgeConfirm = ({ onClose }) => {
  const [month, setMonth] = useState("1");
  const [day, setDay] = useState("1");
  const [year, setYear] = useState("2022");

  const handleSubmit = e => {
    e.preventDefault();
    const age =
      month && day && year
        ? Math.floor(
            (new Date() - new Date(year, month, day).getTime()) / 3.15576e10,
          )
        : 0;

    if (age < 21) {
      alert("You are not old enough to view this content");
    } else {
      Cookies.set("ageConfirm", "confirmed", {
        path: "/",
        secure: true,
        expires: 365,
        domain: process.env.GATSBY_FRONTEND_DOMAIN || "localhost",
      });
      onClose();
    }
  };

  const years = Array.from(
    { length: (2012 - 1910) / 1 + 1 },
    (_, i) => 1910 + i,
  );

  return (
    <Modal
      onClose={onClose}
      // closeOnClickBackground={false}
      closeOnEsc
      // closeOutside
      closeOffset="16px"
      closeIconSize="24px"
      maxWidth="800px"
    >
      <Root>
        <Subtitle>Shine Responsibly®</Subtitle>
        <Question>Are ya over 21?</Question>
        <Desc>Ready to live a little? First, we need some ID!</Desc>

        <form onSubmit={handleSubmit}>
          <Fields>
            <SelectWrapper>
              <Select name="month" onChange={e => setMonth(e.target.value)}>
                <option value="1">Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Select>
            </SelectWrapper>

            <SelectWrapper>
              <Select name="day" onChange={e => setDay(e.target.value)}>
                <option value="1">Day</option>
                {[...Array(31).keys()].map(n => (
                  <option key={n} value={n + 1}>
                    {n + 1}
                  </option>
                ))}
              </Select>
            </SelectWrapper>

            <SelectWrapper>
              <Select name="year" onChange={e => setYear(e.target.value)}>
                <option value="2022">Year</option>
                {years.map(n => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </Select>
            </SelectWrapper>
          </Fields>

          <Submit type="submit">COME IN</Submit>
        </form>
      </Root>
    </Modal>
  );
};

export default ModalAgeConfirm;
